module.exports = __webpack_public_path__ + "img/Path 4 Copy@3x.75fcaf4f.png";